import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToasterUtilService } from '../../../util/toaster-util.service';
import { CadastroModalUtil } from '../../../util/modal/cadastro.modal.util';
import { UtilService } from 'mydatepicker/dist/services/my-date-picker.util.service';
import { AutenticacaoService } from '../../../service/autenticacao.service';
import { Select2OptionData } from 'ng2-select2';

@Component({
  selector: 'app-configuracao-dashboard',
  templateUrl: './configuracao-dashboard.component.html',
  styleUrls: ['./configuracao-dashboard.component.scss']
})
export class ConfiguracaoDashboardComponent implements OnInit {

  entityForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private toasterUtil: ToasterUtilService,
    private cadastroModalUtil: CadastroModalUtil
  ) {

   }

  ngOnInit() {
    this.criarFormGroup();
  }

  criarFormGroup(){
    this.entityForm = this.fb.group({
      notasEmitidas: [2],
      faturamentoDiario: [2],
      notasEmitidasPorHora: [2],
      faturamentoMedioPorHora: [2],
    });
  }

  onCancelar(event){
    this.cadastroModalUtil.closeModal();
  }

  onSalvar(event){
    this.cadastroModalUtil.modelSelect = this.preencherObjeto();
    this.cadastroModalUtil.closeModal();

  }

  preencherObjeto(){

  }



}



// WEBPACK FOOTER //
// ./src/app/shared/componentes/configuracao-dashboard/configuracao-dashboard.component.ts